<template>
  <div>
    <v-container class="container px-0">
      <v-row
        class="title-row"
        :class="`${
          $vuetify.breakpoint.mdAndDown ? 'flex-column flex-nowrap' : ''
        }`"
      >
        <v-col
          class="d-flex align-center"
          :style="
            $vuetify.breakpoint.width <= 1400
              ? ''
              : 'min-width: calc(100% - 482px); max-width: calc(100% - 482px)'
          "
        >
          <h4 class="font-weight-light">{{ $t('heading.hosting.emailForwarders.title') }}</h4>
        </v-col>

        <v-col
          class="page-title__filter-controls justify-end"
          :class="[`${$vuetify.breakpoint.mobile ? 'pb-3' : ''}`]"
        >
          <template v-if="!emailForwarders.loading">
            <data-iterator-filter-controls
              v-if="emailForwarders.items.length"
              :keys="keys"
              :showSearchTerm="true"
              :searchTerm="searchTerm"
              :fullWidthSearch="false"
              :fullWidthLg="false"
              :fullWidthMd="true"
              @update:sortBy="changeSortBy"
              @update:sortDesc="handleSortDescChange"
              @update:searchTerm="handleSearchTermChange"
              :class="'my-hostings-search'"
            />

            <v-btn
              v-if="emailForwarders.items.length"
              :large="!$vuetify.breakpoint.smAndDown"
              elevation="0"
              color="primary"
              class="p-2 add-new-button page-title__add-button"
              @click="showAddForwarderModal"
              :loading="addButtonLoading"
            >
              <v-icon :class="$vuetify.breakpoint.mobile ? 'mr-0' : ''"
              >$plus
              </v-icon
              >
              {{ $vuetify.breakpoint.mobile ? "" : $t('button.emailForwarder.add') }}
            </v-btn>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex align-end">
          <div
            class="acc-select-group w-100"
            :class="showEmailRecordConfiguration ? 'mr-4' : ''"
          >
            <div class="acc-select-label">
              {{ $t('heading.hosting.emailAddress.emailDomain') }}
                <v-tooltip open-delay="150" bottom transition="custom-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-on="on" v-bind="attrs" size="16">$help</v-icon>
                  </template>
                  <div>
                    <p class="p-3 mb-0">
                      {{ $t('tooltip.hosting.emailAddress.emailDomain.tooltip') }}
                    </p>
                  </div>
                </v-tooltip>
            </div>

            <v-select
              class="dns-zone"
              outlined
              :hide-details="true"
              v-model="selectedEmailDomain"
              :items="emailDomains.items"
              item-text="domain"
              item-value="domain"
              :loading="emailDomains.loading"
              @change="reloadEmailForwarders"
              return-object
              :menu-props="{
                offsetY: true,
                nudgeBottom: '8px',
              }"
            >
              <template #item="{ item }">
                <div class="select-sub-item" >
                  {{ item.domain }}
                  <div
                    v-if="showEmailRecordConfiguration && item && item.records_info && !item.records_info.loading && !item.records_info.state"
                    class="select-dot"
                  ></div>
                </div>
              </template>

              <template #selection="{ item }">
                <div class="select-main-item">
                  {{ item.domain }}
                  <div
                    v-if="showEmailRecordConfiguration && item && item.records_info && !item.records_info.loading && !item.records_info.state"
                    class="select-dot"
                  ></div>
                </div>
              </template>
            </v-select>
          </div>
          <v-tooltip
            v-if="showEmailRecordConfiguration && emailDomains.items.length > 0"
            open-delay="150"
            bottom transition="custom-tooltip"
          >
            <template v-slot:activator="{ on, attrs }">
              <div class="record-configuration" v-on="on" v-bind="attrs" @click="openConfigurationModal()">
                <div v-if="selectedEmailDomain === null || selectedEmailDomain.spf_info?.loading"  class="record record-skeleton">
                  <v-skeleton-loader class="skeleton-text" type="text"/>
                  <v-skeleton-loader class="skeleton-label" type="text"/>
                </div>
                <div v-else class="record record-spf">
                  <div class="record-text">{{ $t('heading.hosting.emailAddress.emailDomain.record.spf') }}:</div>
                  <div v-if="selectedEmailDomain.spf_info.state" class="record-label configured">
                    <span>{{ $t('heading.hosting.emailAddress.emailDomain.record.configured') }}</span>
                  </div>
                  <div v-else class="record-label failed">
                    <span>{{ $t('heading.hosting.emailAddress.emailDomain.record.failed') }}</span>
                  </div>
                </div>
                <div v-if="selectedEmailDomain === null || selectedEmailDomain.dkim_info?.loading"  class="record record-skeleton">
                  <v-skeleton-loader class="skeleton-text" type="text"/>
                  <v-skeleton-loader class="skeleton-label" type="text"/>
                </div>
                <div v-else class="record record-dkim">
                  <div class="record-text">{{ $t('heading.hosting.emailAddress.emailDomain.record.dkim') }}:</div>
                  <div v-if="selectedEmailDomain.dkim_info.state" class="record-label configured">
                    <span>{{ $t('heading.hosting.emailAddress.emailDomain.record.configured') }}</span>
                  </div>
                  <div v-else class="record-label failed">
                    <span>{{ $t('heading.hosting.emailAddress.emailDomain.record.failed') }}</span>
                  </div>
                </div>
                <svg class="record-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_13703_12688)"><path d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z" stroke="#797997" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.55 11.25C14.4502 11.4762 14.4204 11.7271 14.4645 11.9704C14.5086 12.2137 14.6246 12.4382 14.7975 12.615L14.8425 12.66C14.982 12.7993 15.0926 12.9647 15.1681 13.1468C15.2436 13.3289 15.2824 13.5241 15.2824 13.7213C15.2824 13.9184 15.2436 14.1136 15.1681 14.2957C15.0926 14.4778 14.982 14.6432 14.8425 14.7825C14.7032 14.922 14.5378 15.0326 14.3557 15.1081C14.1736 15.1836 13.9784 15.2224 13.7812 15.2224C13.5841 15.2224 13.3889 15.1836 13.2068 15.1081C13.0247 15.0326 12.8593 14.922 12.72 14.7825L12.675 14.7375C12.4982 14.5646 12.2737 14.4486 12.0304 14.4045C11.7871 14.3604 11.5362 14.3902 11.31 14.49C11.0882 14.5851 10.899 14.7429 10.7657 14.9442C10.6325 15.1454 10.561 15.3812 10.56 15.6225V15.75C10.56 16.1478 10.402 16.5294 10.1207 16.8107C9.83936 17.092 9.45782 17.25 9.06 17.25C8.66218 17.25 8.28064 17.092 7.99934 16.8107C7.71804 16.5294 7.56 16.1478 7.56 15.75V15.6825C7.55419 15.4343 7.47384 15.1935 7.32938 14.9915C7.18493 14.7896 6.98305 14.6357 6.75 14.55C6.52379 14.4502 6.27286 14.4204 6.02956 14.4645C5.78626 14.5086 5.56176 14.6246 5.385 14.7975L5.34 14.8425C5.20069 14.982 5.03526 15.0926 4.85316 15.1681C4.67106 15.2436 4.47587 15.2824 4.27875 15.2824C4.08163 15.2824 3.88644 15.2436 3.70434 15.1681C3.52224 15.0926 3.35681 14.982 3.2175 14.8425C3.07804 14.7032 2.9674 14.5378 2.89191 14.3557C2.81642 14.1736 2.77757 13.9784 2.77757 13.7812C2.77757 13.5841 2.81642 13.3889 2.89191 13.2068C2.9674 13.0247 3.07804 12.8593 3.2175 12.72L3.2625 12.675C3.4354 12.4982 3.55139 12.2737 3.5955 12.0304C3.63962 11.7871 3.60984 11.5362 3.51 11.31C3.41493 11.0882 3.25707 10.899 3.05585 10.7657C2.85463 10.6325 2.61884 10.561 2.3775 10.56H2.25C1.85218 10.56 1.47064 10.402 1.18934 10.1207C0.908035 9.83936 0.75 9.45782 0.75 9.06C0.75 8.66218 0.908035 8.28064 1.18934 7.99934C1.47064 7.71804 1.85218 7.56 2.25 7.56H2.3175C2.56575 7.55419 2.8065 7.47384 3.00847 7.32938C3.21045 7.18493 3.36429 6.98305 3.45 6.75C3.54984 6.52379 3.57962 6.27286 3.5355 6.02956C3.49139 5.78626 3.3754 5.56176 3.2025 5.385L3.1575 5.34C3.01804 5.20069 2.9074 5.03526 2.83191 4.85316C2.75642 4.67106 2.71757 4.47587 2.71757 4.27875C2.71757 4.08163 2.75642 3.88644 2.83191 3.70434C2.9074 3.52224 3.01804 3.35681 3.1575 3.2175C3.29681 3.07804 3.46224 2.9674 3.64434 2.89191C3.82644 2.81642 4.02163 2.77757 4.21875 2.77757C4.41587 2.77757 4.61106 2.81642 4.79316 2.89191C4.97526 2.9674 5.14069 3.07804 5.28 3.2175L5.325 3.2625C5.50176 3.4354 5.72626 3.55139 5.96956 3.5955C6.21285 3.63962 6.46379 3.60984 6.69 3.51H6.75C6.97183 3.41493 7.16101 3.25707 7.29427 3.05585C7.42753 2.85463 7.49904 2.61884 7.5 2.3775V2.25C7.5 1.85218 7.65804 1.47064 7.93934 1.18934C8.22064 0.908035 8.60218 0.75 9 0.75C9.39782 0.75 9.77936 0.908035 10.0607 1.18934C10.342 1.47064 10.5 1.85218 10.5 2.25V2.3175C10.501 2.55884 10.5725 2.79463 10.7057 2.99585C10.839 3.19707 11.0282 3.35493 11.25 3.45C11.4762 3.54984 11.7271 3.57962 11.9704 3.5355C12.2137 3.49139 12.4382 3.3754 12.615 3.2025L12.66 3.1575C12.7993 3.01804 12.9647 2.9074 13.1468 2.83191C13.3289 2.75642 13.5241 2.71757 13.7213 2.71757C13.9184 2.71757 14.1136 2.75642 14.2957 2.83191C14.4778 2.9074 14.6432 3.01804 14.7825 3.1575C14.922 3.29681 15.0326 3.46224 15.1081 3.64434C15.1836 3.82644 15.2224 4.02163 15.2224 4.21875C15.2224 4.41587 15.1836 4.61106 15.1081 4.79316C15.0326 4.97526 14.922 5.14069 14.7825 5.28L14.7375 5.325C14.5646 5.50176 14.4486 5.72626 14.4045 5.96956C14.3604 6.21285 14.3902 6.46379 14.49 6.69V6.75C14.5851 6.97183 14.7429 7.16101 14.9442 7.29427C15.1454 7.42753 15.3812 7.49904 15.6225 7.5H15.75C16.1478 7.5 16.5294 7.65804 16.8107 7.93934C17.092 8.22064 17.25 8.60218 17.25 9C17.25 9.39782 17.092 9.77936 16.8107 10.0607C16.5294 10.342 16.1478 10.5 15.75 10.5H15.6825C15.4412 10.501 15.2054 10.5725 15.0042 10.7057C14.8029 10.839 14.6451 11.0282 14.55 11.25V11.25Z" stroke="#797997" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_13703_12688"><rect width="18" height="18" fill="white"/></clipPath></defs></svg>
              </div>
            </template>
            <div>
              <p class="p-3 mb-0">
                {{ $t('tooltip.hosting.emailAddress.emailDomain.record.tooltip') }}
              </p>
            </div>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="mt-3 px-0">
      <v-row>
        <v-col cols="12">
          <div :class="checkedItems.length > 0 ? 'pb-15' : ''">
            <hosting-table
              v-if="!isError"
              :headers="headers"
              :items="emailForwarders.items"
              :itemsLoading="emailForwarders.loading"
              :itemsPerPage="itemsPerPage"
              :itemsTotal="itemsTotal"
              :page="page"
              :possibleItemsPerPage="[[8, 16, 24]]"
              :searchTerm="searchTerm"
              :sortBy="sortBy"
              :sortDesc="sortDesc"
              @clearFilters="searchTerm = ''"
              @update:check-all="handleSelectAll"
              @update:checked-items="handleItemCheck"
              @update:itemsPerPage="changePerPage"
              @update:page="changePage"
              @update:sortBy="changeSortBy"
              @update:sortDesc="changeSortDesc"
              :itemClass="itemClass"
            >
              <template v-slot:no-data>
                <TableFullScreenMessage
                  :title="$t('message.emptyTable.emailForwarders.title')"
                  :desc="$t('message.emptyTable.emailForwarders.description')"
                >
                  <template v-slot:image>
                    <hosting-email-forwarders-illustration/>
                  </template>
                  <template v-slot:action>
                    <v-btn
                      :large="!$vuetify.breakpoint.smAndDown"
                      :small="$vuetify.breakpoint.smAndDown"
                      elevation="0"
                      color="primary"
                      class="p-2 ml-0 add-new-button"
                      @click="showAddForwarderModal"
                      :loading="addButtonLoading"
                      rounded
                    >
                      <v-icon :class="$vuetify.breakpoint.mobile ? 'mr-0' : ''"
                      >$plus
                      </v-icon
                      >
                      {{ $vuetify.breakpoint.mobile ? "" : $t('button.emailForwarder.add') }}
                    </v-btn>
                  </template>
                </TableFullScreenMessage>
              </template>
              <template v-slot:actions="item">
                <v-tooltip
                  transition="custom-tooltip"
                  open-delay="150"
                  bottom
                  z-index="99"
                  offset-overflow
                  nudge-bottom="4px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      icon
                      small
                      @click="showDeleteForwarderModal(item)"
                    >
                      <v-icon>$thrash</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('button.emailForwarder.delete') }}</span>
                </v-tooltip>
              </template>

              <template v-slot:mobile="{ item, headers }">
                <div class="mobile-table-item__row">
                  <div
                    class="mobile-table-item__header"
                    @click="$emit('update:sortBy', headers[0])"
                  >
                    {{ $t('table.header.email') }}
                  </div>
                  <div class="mobile-table-item__value">
                    <span class="bold p-3">{{ item.email }}</span>
                  </div>
                </div>
                <div class="mobile-table-item__row">
                  <div
                    class="mobile-table-item__header"
                    @click="$emit('update:sortBy', headers[1])"
                  >
                    {{ $t('table.header.forwardTo') }}
                  </div>
                  <div class="mobile-table-item__value">
                    <span class="bold p-3">{{ item.forward_to }}</span>
                  </div>
                </div>
              </template>
              <template v-slot:updated_at="item">
                <span>{{ item.updated_at_text }}</span>
              </template>
            </hosting-table>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      transition="custom-dialog-transition"
      :persistent="modalOptions.persistent"
      v-model="modalOptions.open"
      ref="dialog"
    >
      <div
        class="card-overlay"
        v-if="!modalOptions.persistent"
        @click="modalOptions.open = !modalOptions.open"
      />
      <div class="card-overlay" v-else @click="$refs.dialog.animateClick()"/>
      <basic-modal
        style="width: 560px"
        :modalOptions="modalOptions"
        @modal-close="modalClose"
        :key="modalRender"
        ref="modal"
      />
    </v-dialog>
    <v-dialog
      transition="custom-dialog-transition"
      v-model="modalConfigurationOpen"
      ref="dialog"
    >
      <div
        class="card-overlay"
        @click="closeConfigurationModal()"
      />
      <record-configuration
        style="width: 560px"
        @modal-close="closeConfigurationModal()"
        :domain="selectedEmailDomain"
      />
    </v-dialog>
  </div>
</template>

<script>
import Api from "../../apis/Api";

import BasicModal from "../../components/modal/BasicModal";
import DataIteratorFilterControls from "../../components/dataIterator/DataIteratorFilterControls.vue";
import HostingTable from "../../components/dataIterator/tables/HostingTable.vue";
import TableFullScreenMessage from "../../components/dataIterator/tables/TableFullScreenMessage.vue";
import HostingEmailForwardersIllustration
  from "../../components/illustrations/hosting/hosting-email-forwarders-illustration.vue";
import ActionModalMixin from "../../mixins/ActionModalMixin";
import DataIteratorPageMixin from "../../mixins/DataIteratorPageMixin";
import CustomTablePageMixin from "../../mixins/CustomTablePageMixin";
import moment from "moment";
import EmailForwardersActionsMixin from "../../mixins/EmailForwardersActionsMixin";
import EmailDomainRecordsMixin from "../../mixins/EmailDomainRecordsMixin";
import RecordConfiguration from "../../components/modal/RecordConfiguration.vue";

export default {
  components: {
    RecordConfiguration,
    BasicModal,
    DataIteratorFilterControls,
    HostingTable,
    TableFullScreenMessage,
    HostingEmailForwardersIllustration,
  },
  mixins: [ActionModalMixin, DataIteratorPageMixin, CustomTablePageMixin, EmailForwardersActionsMixin, EmailDomainRecordsMixin],
  data() {
    return {
      isServerProvided: false,
      sortBy: "updated_at",
      sortDesc: false,
      searchTerm: "",
      headers: [
        {
          text: 'email',
          value: "email",
          sortable: true,
        },
        {
          text: 'forwardTo',
          value: "forward_to",
          sortable: true,
        },
        {
          text: 'created',
          value: "updated_at",
          sortable: true,
        },
        {
          text: 'actions',
          value: "actions",
        },
      ],
      page: 1,
      addButtonLoading: false,
      itemsPerPage: 8,
      modalRender: 0,
      modalOptions: {open: false},
      modalConfigurationOpen: false,
      highlightItem: {},
      selectedEmailDomain: null,
      emailDomains: {
        loading: false,
        items: []
      },
      emailForwarders: {
        loading: false,
        items: []
      },
      isError: false,
      showEmailRecordConfiguration: false,
    };
  },
  props: {
    service: Object
  },
  watch: {
    highlightItem: function (newValue) {
      if (!newValue) return;
      setTimeout(() => {
        this.highlightItem = {};
      }, 1000);
    },
    service: function () {
      this.reloadEmailDomains();
    },
    "modalOptions.open": function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
    },
    "modalConfigurationOptions.open": function (value) {
      value
        ? this.$store.dispatch("lockBodyScroll")
        : this.$store.dispatch("unlockBodyScroll");
    },
  },
  computed: {
    itemsTotal: function () {
      return this.emailForwarders.items.length;
    },
  },
  methods: {
    openConfigurationModal() {
      this.modalConfigurationOpen = true;
    },
    closeConfigurationModal() {
      this.modalConfigurationOpen = false;
    },
    reloadEmailDomains() {
      this.emailDomains.loading = true;
      this.isError = false;
      Api.cached(0)
        .get(`/services/${this.service.id}/email/domains`)
        .then((response) => {
          this.showEmailRecordConfiguration = response.data.meta.is_email_dns_records_showed;
          this.emailDomains.items = response.data.data.map((domain) => {
            return this.initEmailDomainInfo(domain);
          })
          if (response.data.data.length) {
            this.selectedEmailDomain = response.data.data[0];
            this.checkAllDomains(this.emailDomains.items);
            this.reloadEmailForwarders();
          } else {
            this.emailForwarders.items = [];
            this.emailForwarders.loading = false;
          }
        })
        .catch((error) => {
          this.isError = true;
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.emailDomains.loading = false;
        });
    },
    reloadEmailForwarders(emailDomain = null) {
      if (emailDomain !== null) {
        this.selectedEmailDomain = emailDomain;
      }
      this.emailForwarders.loading = true;
      this.isError = false;
      if (this.selectedEmailDomain === null) {
        this.emailForwarders.loading = false;
        return;
      }

      Api.get(`/services/${this.service.id}/email/domains/${this.selectedEmailDomain.id}/forwarders`)
        .then((response) => {
          this.emailForwarders.items = response.data.data.map((item) => {
            item.updated_at_text = item.updated_at
              ? moment(item.updated_at).fromNow()
              : "-";
            return item;
          });
        })
        .catch((error) => {
          this.isError = true;
          this.$store.dispatch("addAlert", {
            success: false,
            errorMessage: Api.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.emailForwarders.loading = false;
        });
    },
    itemClass(item) {
      if (
        this.highlightItem.email &&
        item.email == this.highlightItem.email &&
        item.forward_to == this.highlightItem.forward_to
      ) {
        return "highlight";
      }
    },
  },
  mounted() {
    if (this.service) {
      this.reloadEmailDomains();
    }
  },
};
</script>

<style scoped lang="scss">
.title-row {
  @media (min-width: 1401px) {
    height: 70px;
  }
}

.acc-select-group{
  min-width: 260px;
  display: flex;
  flex-direction: column;
  .acc-select{
    &-label{
      color: var(--v-gray-darken1);
      margin-right: 4px;
      margin-bottom: 4px;
      font-size: 14px;
      font-style: normal;
      svg{
        cursor: pointer;
        width: 16px;
        height: 16px;
        transition: 0.3s;
        &:hover{
          path{
            stroke: var(--v-primary-base);
          }
        }
      }
    }
  }
}
.select{
  &-sub-item{
    display: flex;
    align-items: center;
    transition: 0.3s;
    &:hover{
      color: var(--v-primary-base)
    }
  }
  &-main-item{
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  &-dot{
    width: 8px;
    height: 8px;
    border-radius: 8px;
    margin-left: 8px;
    background: var(--v-error-base);
  }
}
.record-configuration{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 16px;
  height: 48px;
  border: 1px solid var(--v-gray-lighten2);
  border-radius: 5px;
  min-width: 400px;
  gap: 16px;
  transition: 0.3s;
  cursor: pointer;
  .record{
    display: flex;
    &-text{
      white-space: nowrap;
    }
    &-label{
      margin-left: 8px;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      padding: 3px 5px;
      border-radius: 5px;
      text-transform: capitalize;
      &.failed{
        color: var(--v-error-base);
        background: rgba(231, 29, 29, 0.15);
      }
      &.configured{
        color: var(--v-primary-darken1);
        background: var(--v-primary-lighten2)
      }
    }
    &-icon{
      transition: 0.3s;
    }
  }
  &:hover{
    border-color: var(--v-primary-base);
    .record-icon{
      path{
        stroke: var(--v-primary-base);
        path{
          stroke: var(--v-primary-base);
        }
      }
    }
  }
}

</style>
